import React from "react";
import { useStepData } from "../../../hooks/useStepData";
import { useFunnelNavigation } from "../../../hooks/useFunnelNavigation";
import { CheckboxButton } from "../../common/CheckboxButton";
import { StepHeader } from "../../common/StepHeader";
import { Footer } from "../../common/Footer";

export function MultiSelect({ config }) {
  const { data = [], updateStepData } = useStepData(config.field);
  const { nextStep } = useFunnelNavigation();

  const handleSelect = (optionId) => {
    const newSelection = data.includes(optionId)
      ? data.filter((id) => id !== optionId)
      : [...data, optionId];
    updateStepData(newSelection);
  };

  return (
    <div className="px-4">
      <div className="flex-1">
        <StepHeader
          title={config.title}
          subtitle={config.subtitle}
          order={config.headerOrder}
        />

        <div className="space-y-2">
          {config.options.map((option) => (
            <CheckboxButton
              key={option.id}
              text={option.text}
              emoji={option.emoji}
              selected={data.includes(option.id)}
              onClick={() => handleSelect(option.id)}
            />
          ))}
        </div>
      </div>

      {data.length > 0 && (
        <Footer onClick={nextStep}>{config.buttonText || "Next"}</Footer>
      )}
    </div>
  );
}
